import {Select} from '@priority-software/priority-style-react';
import React, {useEffect, useState} from 'react';
import styles from '../styles/templateInput.module.scss';

export const LangSelect = ({options, templateLang, onLangSelect}) => {
    const [langs, setLangs] = useState([]);

    useEffect(() => {
        setLangs(
            options.map(l => {
                return {
                    value: l.lang,
                    label: l.langtitle
                };
            })
        );
    }, [options]);

    return (
        <Select
            value={langs.find(l => l.value === templateLang)}
            options={langs}
            menuWidth={100}
            isSearchable={false}
            menuScrollMaxHeight={200}
            componentClasses={styles.select}
            onChange={onLangSelect}
        />
    );
};
